import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
    Typography,
    AppBar,
    Toolbar,
    Link,
    CardActionArea,
    TextField,
    Button,
    Chip,
    Paper,
    FormControlLabel,
    IconButton,
    Avatar,
    Tooltip,
} from "@material-ui/core";
import {
    CircularProgress,
    Grid,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    DialogContentText,
    LinearProgress,
    InputLabel,
    Select,
    FormHelperText,
    MenuItem,
    FormControl,
    Switch,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    ListItemSecondaryAction, Input
} from "@material-ui/core";
import {
    DesktopMac,
    Add,
    FilterList,
    CheckCircle,
    Block,
    Delete,
    Edit,
    AccountCircle,
    Close,
    PermIdentity,
    ArrowForwardIos,
    SubdirectoryArrowLeftOutlined,
    AccountBalance,
    Schedule,
    Money,
    VpnLock,
    ThumbUp,
    ThumbDown
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";
import { useRoles, useOrgRoles } from "../../../hooks/use_hooks";

import MUIDataTable from "mui-datatables";
import MaskedInput from "react-text-mask";

import { makeStyles } from "@material-ui/styles";
import {
    FinanceService,
    AdminService,
    ReportingService,
    Validator,
    Permissions,
} from "../../../../../utils/web_config";
import { useSnackbar } from "notistack";
import Format from 'date-fns/format';

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        [theme.breakpoints.up("sm")]: {
            marginLeft: 250,
        },
    },
    title: {
        flexGrow: 1,
    },
    btn: {
        textTransform: "capitalize",
    },
    btn2: {
        textTransform: "capitalize",
        border: "dashed grey 1px",
    },
    paper: {
        padding: 15,
    },
    action: {
        borderRadius: 15,
    },
}));

function MaskedNID(props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={(ref) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={[
                /\d/,
                " ",
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                " ",
                /\d/,
                " ",
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                " ",
                /\d/,
                " ",
                /\d/,
                /\d/,
            ]}
            placeholderChar={"\u2000"}
            showMask={false}
            keepCharPositions={true}
        />
    );
}


function RefundRequest(props) {
    const classes = useStyles();
    const history = useHistory();

    const ad = localStorage.getItem("nx_cent");
    const roles = useOrgRoles({
        org_id: JSON.parse(ad)?.organization.organization_id,
    });

    const [accountData, setAccountData] = useState({});

    const [addNewOpen, setAddNewOpen] = useState(false);

    const [agents, setAgents] = useState({
        page: 0,
        count: 1,
        rowsPerPage: 10,
        sortOrder: {},
        saving: false,
        loading: false,
        toggling: false,
        data: [],
    });

    const [selectedAgent, setSelectedAgent] = useState({
        saving: false,
        loading: false,
        data: {},
    });

    const [agentAccount, setAgentAccount] = useState({
        saving: false,
        loading: false,
        data: {},
    });

    const [agentEditMode, setAgentEditMode] = useState({
        status: false,
        suspend: false,
    });

    const [hasCode, setHasCode] = useState({
        open: false,
        loading: false,
    });



    const [id, setId] = useState({ value: "", error: "" });
    const [idData, setIdData] = useState({
        loading: false,
        saving: false,
        open: false,
    });

    const [status, setStatus] = useState("Loading individual agents....");
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [firstName, setFirstName] = useState({ value: "", error: "" });
    const [lastName, setLastName] = useState({ value: "", error: "" });
    const [email, setEmail] = useState({ value: "", error: "" });
    const [agentUsername, setAgentUsername] = useState({ value: "", error: "" });
    const [phone, setPhone] = useState({ value: "", error: "" });
    const [NID, setNid] = useState({ value: "", error: "" });
    const [gender, setGender] = useState({ value: "", error: "" });

    const [agentTin, setTin] = useState({ value: "", error: "" });

    const [password, setPassword] = useState({ value: "", error: "" });

    const [role, setRole] = useState({ value: "", error: "" });

    useEffect(() => {
        var accountData = new AdminService().accountData;
        console.log(accountData);
        setAccountData(accountData);
        getcustomerRefundRequests(accountData.token,accountData.user_id);
        getUsers(accountData.token, accountData.organization?.organization_id);
    }, []);


    const getUsers = (token, id) => {
        const usersInstance = axios.create(new AdminService().getHeaders(token));

        setUsers({ ...users, loading: true });

        usersInstance
            .get(new AdminService().GET_USERS_BY_TYPE + 'ORG_USER?size=10000')
            .then(function (response) {
                console.log(response.data.data)
                setUsers({ ...users, loading: false });

                const d = response.data;
                var usrs = [];

                d.data.forEach((u, i) => {
                    const newUser = u;
                    newUser["status2"] = u.user_status;
                    newUser["user_names"] = u.user_first_name + " " + u.user_last_name;

                    usrs.push(u);
                });

                setUsers({
                    ...users,
                    data: usrs,
                });
            })
            .catch(function (error) {
                setUsers({ ...users, loading: false });
                var e = error.message;

                if (error.response) {
                    e = error.response.data.message;
                }


                notify(error?.response?.status == 404 ? "info" : "error", e, error?.response?.status);
            });
    };



    const clearUserInfo = () => {
        setRole({ value: "", error: "" });
        setEmail({ value: "", error: "" });
        setFirstName({ value: "", error: "" });
        setLastName({ value: "", error: "" });
        setAgentUsername({ value: "", error: "" });
        setNid({ value: "", error: "" });
        setPassword({ value: "", error: "" });
        setPhone({ value: "", error: "" });
    };
    /////////////
    const toggleUser = (id) => {
        const assInstance = axios.create(
            new AdminService().getHeaders(accountData.token)
        );

        const user = agents.data.filter((obj) => obj.user_id == id)[0];
        const i = agents.data.indexOf(user);

        var url =
            user.user_status == "ENABLED"
                ? new AdminService().DEACTIVATE_USER + id
                : new AdminService().REACTIVATE_USER + id;

        user["user_status"] =
            user.user_status == "ENABLED" ? "DISABLED" : "ENABLED";

        console.log("togglinguser.....");

        setAgents({ ...agents, toggling: true });

        assInstance
            .put(url)
            .then(function (response) {
                const d = response.data;

                user["status2"] = user.user_status;

                const usrs = agents.data;
                usrs[i] = user;
                setAgents({ ...agents, data: usrs, toggling: false });

                notify("success", d.data);
            })
            .catch(function (error) {
                user["user_status"] =
                    user.user_status == "ENABLED" ? "DISABLED" : "ENABLED";

                user["status2"] = user.user_status;

                const usrs = agents.data;
                agents[i] = user;
                setAgents({ ...agents, data: usrs, toggling: false });

                var e = error.message;

                if (error.response) {
                    e = error.response.data.message;
                }
                notify(error?.response?.status == 404 ? "info" : "error", e, error?.response?.status);
            });
    };
    ////////////////////////////////
    //////////////
    const showAgentEdit = (id) => {
        setAddNewOpen(true);
        setAgentEditMode({ ...agentEditMode, status: true, id: id });

        const agent = agents.data.filter((obj) => obj.user_id == id)[0];
        const i = agents.data.indexOf(agent);

        setFirstName({ ...firstName, value: agent.user_first_name });
        setLastName({ ...lastName, value: agent.user_last_name });
        setEmail({ ...email, value: agent.user_email });
        setGender({ ...gender, value: agent.user_gender });
        setPhone({ ...phone, value: agent.user_phone });
        setNid({ ...lastName, value: agent.user_nid });
    };

    ////////////////////////////////

    const columns = [
        {
            name: "id",
            label: "Transaction id",
            options: {
                filter: false,
                sort: false,
                display: "excluded",
            },
        },
        {
            name: "description",
            label: "Description",
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: "request_type",
            label: "Request Type",
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: "amount",
            label: "Amount",
            options: {
                filter: false,
                sort: false,
            },
        },

        {
            name: "debited_account",
            label: "Customer Account Number",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "r_date",
            label: "Date",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "r_time",
            label: "Time",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: function (dataI,rowI){
                    return (
                        <Typography>{Format(Date.parse(agents.data[dataI].r_time), ['HH:mm:ss'])}</Typography>
                    );
                }
            },

        },
        {
            name: "status",
            label: "status",
            options: {
                filter: true,
                display: "excluded",
            },
        },

        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: function (dataI, rowI) {
                    return (
                        <Chip
                            avatar={
                                <Avatar>
                                    {agents.data[dataI].status.toLowerCase() == "approved" ? (
                                        <CheckCircle fontSize="small" />
                                    ) : (
                                        <Block fontSize="small" />
                                    )}
                                </Avatar>
                            }
                            variant="outlined"
                            color={
                                agents.data[dataI].status.toLowerCase() == "approved"
                                    ? "primary"
                                    : "default"
                            }
                            size="small"
                            label={capitalize(agents.data[dataI]?.status)}
                        />
                    );
                },
            },
        },
    ];


    const options = {
        filterType: "multiselect",
        elevation: 0,
        selectableRows: "single",
        searchPlaceholder: "Search agent...",
        selectableRowsOnClick: true,
        fixedHeader: true,
        searchProps: {
            variant: "outlined",
            margin: "dense",
        },
        textLabels: {
            body: {
                noMatch: status,
            },
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
            <CustomUsersToolbar
                selectedRows={selectedRows}
                displayData={displayData}
                setSelectedRows={setSelectedRows}
                toggleUser={toggleUser}
                confirmTransactionRequest={confirmTransactionRequest}
                toggling={agents.toggling}
            />
        ),
    };

    const notify = (variant, msg, status) => {
        if (status == 401) {
            history.push("/", { expired: true });
        }
        enqueueSnackbar(msg, {
            variant: variant,
            action: (k) => (
                <IconButton
                    onClick={() => {
                        closeSnackbar(k);
                    }}
                    size="small"
                >
                    <Close fontSize="small" />
                </IconButton>
            ),
        });
    };

    const capitalize = (s) => {
        return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
    };

    const getcustomerRefundRequests = (token, id) => {
        const agentTopupRequestInstance = axios.create(new AdminService().getHeaders(token));

        setAgents({ ...agents, loading: true });

        console.log("getting agents topup request .....");

        agentTopupRequestInstance
            .get(new FinanceService().GET_TRANSACTION_REQUEST + '?request_type=REFUND&approver=' + id +'&per_page=10000')
            .then(function (response) {
                setAgents({ ...agents, loading: false });

                const d = response.data;

                if (d.data.length == 0) {
                    setStatus("There are no agent topup request available.");
                } else {
                    // var usrs = [];

                    // d.data.forEach((u, i) => {
                    //     const newUser = u;
                    //     newUser["status2"] = u.user_status;
                    //     newUser["user_names"] = u.user_first_name + " " + u.user_last_name;

                    //     usrs.push(u);
                    // });

                    setAgents({
                        ...agents,
                        data: d.data,
                    });
                }
            })
            .catch(function (error) {
                setAgents({ ...agents, loading: false });
                var e = error.message;

                if (error.response) {
                    e = error.response.data.message;
                }
                setStatus(e);

                notify(error?.response?.status == 404 ? "info" : "error", e, error?.response?.status);
            });
    };


    const confirmTransactionRequest = (status,id) => {
        const agentTopupRequestInstance = axios.create(new AdminService().getHeaders(accountData.token));

        setAgents({ ...agents, loading: true });

        console.log("getting agents topup request .....");

        const topUpRequest = agents.data.filter((obj) => obj.id == id)[0];
        const i = agents.data.indexOf(topUpRequest);

        agentTopupRequestInstance
            .put(new FinanceService().CONFIRM_TRANSACTION_REQUEST,
            {
                "transaction_request_id":id,
                "status":status
            })
            .then(function (response) {

                const d = response.data;
                topUpRequest["status"] = d.data.status;
                const usrs = agents.data;
                usrs[i] = topUpRequest;
                setAgents({ ...agents, data: usrs, loading: false });
                notify("success", d.data);
            })
            .catch(function (error) {
                setAgents({ ...agents, loading: false });
                var e = error.message;

                if (error.response) {
                    e = error.response.data.message;
                }
                setStatus(e);

                notify(error?.response?.status == 404 ? "info" : "error", e, error?.response?.status);
            });
    };


    const [users, setUsers] = useState({
        page: 0,
        count: 1,
        rowsPerPage: 10,
        sortOrder: {},
        saving: false,
        loading: false,
        toggling: false,
        data: [],
    });

    const onApproverChange = (event) => {
        if (event.target.value === "") {
            setApprover({
                value: "",
                error: "Please Choose Approver",
            });
        } else {
            setApprover({ value: event.target.value, error: "" });
        }
    };


    const [cardNumber,setCardNumber]=useState({value:"",error:""})
    const [approver,setApprover]=useState({value:0,error:""})
    const [description, setDescription]=useState({value:"",error:""})
    const [newLoad,setNewLoad]=useState(false)

    const requestRefund = ()=>{
        if (cardNumber.value===""){
            setCardNumber({ ...cardNumber ,error:"Invalid card number"})
            return
        } else if (description.value===""){
            setDescription({ ...description, error: "Invalid description" })
            return
        } else if (approver.value===0){
            setApprover({...approver,error:"Invalid approver"})
            return
        }else{
            const refundRequestInstance = axios.create(new AdminService().getHeaders(accountData.token));
            setNewLoad(true)
            const topUpRequest = agents.data.filter((obj) => obj.id == id)[0];
            const i = agents.data.indexOf(topUpRequest);
            refundRequestInstance
                .post(new FinanceService().REFUND_REQUEST,
                    {
                        channel_type: "WEB",
                        card_number: cardNumber.value,
                        approver: approver.value,
                        request_type: "REFUND",
                        description: description.value
                    })
                .then(function (response) {
                    setNewLoad(false)
                    const {status} = response.data.data;
                    notify("success", "Request sent successfully", status);
                    getcustomerRefundRequests(accountData.token, accountData.user_id)
                    setAddNewOpen(false)
                })
                .catch(function (error) {
                    setNewLoad(false)
                    var e = error.message;
                    if (error.response) {
                        e = error.response.data.message;
                    }
                    setStatus(e);
                    notify(error?.response?.status == 404 ? "info" : "error", e, error?.response?.status);
                });
        }

    }




    return (
        <div className={classes.root}>
            <Box display="flex">
                <Box mr={2}>
                    {" "}
                    <Money color="primary" fontSize="large" />
                </Box>
                <Box flexGrow={1} display="flex" alignItems="center">
                    <Typography variant="h5">
                        <b>Customer</b>
                    </Typography>
                    <Box ml={1} mr={1} mt={1}>
                        <ArrowForwardIos fontSize="small" />
                    </Box>
                    <Typography variant="h6">Refund Request</Typography>
                </Box>
                    <Button
                        className={classes.btn}
                        color="primary"
                        variant="contained"
                        size="medium"
                        startIcon={<Add />}
                        disableElevation
                        onClick={() => {
                            setAddNewOpen(true);
                        }}
                    >
                        New Request
                    </Button>
            </Box>
            <Box mt={3} />

            {agents.loading && <LinearProgress />}
            <MUIDataTable
                title={"List of refund requests"}
                data={agents.data}
                columns={columns}
                options={options}
            />

            <Dialog
                open={addNewOpen}
                fullWidth={true}
                maxWidth={"sm"}
                onClose={() => setAddNewOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Refund Request"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Submit customer refund request
                    </DialogContentText>

                    <Box mt={2}>
                        <FormControl
                            fullWidth
                            variant="outlined"
                            size="small"
                            error={approver.error !== ""}
                        >
                            <InputLabel>
                                Approver
                            </InputLabel>
                            <Select
                                label={"Choose Approver"}
                                value={approver.value}
                                onChange={onApproverChange}
                            >
                                {users.data.filter(o => process.env.REACT_APP_APPROVERS.includes(o.user_name)).map((c, i) => (
                                    <MenuItem value={c.user_id}>{c.user_names}</MenuItem>
                                ))}
                            </Select>
                            <FormHelperText>{approver.error}</FormHelperText>
                        </FormControl>
                    </Box>

                    <Box mt={2}>
                        <TextField
                            size="small"
                            variant="outlined"
                            color="primary"
                            value={cardNumber.value}
                            placeholder={"Card Number"}
                            label={"Card Number"}
                            fullWidth
                            onChange={(e)=>{
                                if(e.target.value!==""){
                                    setCardNumber({value:e.target.value,error:""})
                                }else{
                                    setCardNumber({value:"",error:"Invalid card number"})
                                }
                            }}
                            helperText={cardNumber.error}
                            error={cardNumber.error !== ""}
                        />
                    </Box>
                    <Box mt={2}>
                        <TextField
                            size="small"
                            variant="outlined"
                            color="primary"
                            multiline
                            rows={3}
                            rowsMax={5}
                            value={description.value}
                            placeholder={"Description"}
                            label={"Description"}
                            fullWidth
                            onChange={(e)=>{
                                if(e.target.value!==""){
                                    setDescription({value:e.target.value,error:""})
                                }else{
                                    setDescription({value:"",error:"Invalid Description"})
                                }
                            }}
                            helperText={description.error}
                            error={description.error !== ""}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        onClick={() => {
                            setAddNewOpen(false);
                        }}
                        color="primary"
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        autoFocus
                        disabled={newLoad}
                        onClick={requestRefund}
                        disableElevation
                    >
                        {newLoad ? <CircularProgress size={23} /> : "Request"}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

function CustomUsersToolbar(props) {
    const { toggleUser, displayData, selectedRows, confirmTransactionRequest } = props;

    console.log("datadata")
    console.log(displayData[selectedRows?.data[0]?.index]?.data)

    return (
        displayData[selectedRows?.data[0]?.index]?.data[7]=="PENDING"?

        <Box display="flex" alignItems="center">
                <Button
                    color="primary"
                    variant="outlined"
                    size="small"
                    startIcon={<ThumbUp />}
                    onClick={() =>{
                        confirmTransactionRequest("APPROVED", displayData[selectedRows?.data[0]?.index]?.data[0])
                    }
                        
                    }
                >
                    Approve
                </Button>

            <Box mr={2} ml={2}>
                <Button
                    color="secondary"
                    variant="outlined"
                    size="small"
                    startIcon={<ThumbDown />}
                onClick={() =>{
                    confirmTransactionRequest("REJECTED", displayData[selectedRows?.data[0]?.index]?.data[0])
                }}
                >
                    Reject
                </Button>
            </Box>
        </Box>:<></>
    );
}
export default withLocalize(RefundRequest);